__turbopack_context__.v({
  "result": "NYX_ja_result",
});
